var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArmaturaDubla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eecb8dea-4059-49d4-8bd6-5e0d31f5d2f0",
    "data-name": "armatura",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a62ffbc2-76a4-499b-8ff9-51a6f59705db,.edf5a39a-d1c3-488b-9fdc-435d81ff15ba{fill:none;}.bf20b7f6-1388-4f46-93f4-7ddb6173a22c{clip-path:url(#ab504402-f527-4a8f-b64c-ae4cfe31ddfd);}.edf5a39a-d1c3-488b-9fdc-435d81ff15ba{stroke:#000;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab504402-f527-4a8f-b64c-ae4cfe31ddfd",
    transform: "translate(0 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a62ffbc2-76a4-499b-8ff9-51a6f59705db",
    width: 200,
    height: 200
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "armatura_dubla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bf20b7f6-1388-4f46-93f4-7ddb6173a22c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190-25.15v209.3a4,4,0,0,1-4,4H14a4,4,0,0,1-4-4V-21.15a4,4,0,0,1,4-4H190M200-33a4,4,0,0,0-4-4H4a4,4,0,0,0-4,4V196a4,4,0,0,0,4,4H196a4,4,0,0,0,4-4Z",
    transform: "translate(0 37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "edf5a39a-d1c3-488b-9fdc-435d81ff15ba",
    x: 40,
    y: 5.01,
    width: 120,
    height: 190.4,
    rx: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmaturaDubla);
export default __webpack_public_path__ + "static/media/armatura_dubla.aaaf22881eb60fd9fd6613fa98e50315.svg";
export { ForwardRef as ReactComponent };